export default {
    services: [{
        "code": ".5 Hours",
        "name": "30 Minutes working as required.",
        "isSold": true,
        "isPurchased": false,
        "description": "Service: 30 Minutes working as required\n\nDuration: 30 \n\nDescription:",
        "purchaseDetails": {},
        "salesDetails": {
            "unitPrice": 27.5,
            "accountCode": "201",
            "taxType": "OUTPUT2"
        },
        "isTrackedAsInventory": false,
        "updatedDateUTC": "2021-12-17T15:43:44.483Z",
        "itemID": "44718783-753e-4e35-b980-f89694f6facc"
    },
        {
            "code": ".75 Hours",
            "name": "45 Minutes working as required.",
            "isSold": true,
            "isPurchased": false,
            "description": "Service: 45 Minutes working  as required\n\nDuration: 45\n\nDescription:",
            "purchaseDetails": {},
            "salesDetails": {
                "unitPrice": 41.25,
                "accountCode": "201",
                "taxType": "OUTPUT2"
            },
            "isTrackedAsInventory": false,
            "updatedDateUTC": "2021-12-17T15:43:57.480Z",
            "itemID": "42631327-5d0b-4f7a-bf27-f78ab52dc75f"
        },
        {
            "code": "1.5 Hours",
            "name": "1.5 Hours working as required",
            "isSold": true,
            "isPurchased": false,
            "description": "Service: 1.5 Hour working as required\n\nDuration: 90\n\nDescription:",
            "purchaseDetails": {},
            "salesDetails": {
                "unitPrice": 82.5,
                "accountCode": "201",
                "taxType": "OUTPUT2"
            },
            "isTrackedAsInventory": false,
            "updatedDateUTC": "2021-12-17T15:44:15.227Z",
            "itemID": "ca20b31e-b934-426f-b7fb-15d861d065df"
        },
        {
            "code": "10 Hours",
            "name": "10 Hours working  as required",
            "isSold": true,
            "isPurchased": false,
            "description": "Service: 10 Hour working as required\n\nDuration: 600\n\nDescription:",
            "purchaseDetails": {},
            "salesDetails": {
                "unitPrice": 550,
                "accountCode": "201",
                "taxType": "OUTPUT2"
            },
            "isTrackedAsInventory": false,
            "updatedDateUTC": "2021-12-17T15:44:24.470Z",
            "itemID": "ab84a193-aec2-4c9c-a745-ffc0894a17ba"
        }],
    technicians: [{
        "TrackingOptionID": "34b8fd75-283a-47b2-a3de-19e0f2a053af",
        "Name": "Aaron",
        "Status": "ACTIVE",
        "HasValidationErrors": false,
        "IsDeleted": false,
        "IsArchived": false,
        "IsActive": true
    },
        {
            "TrackingOptionID": "2ed5975a-f33f-4ea0-9106-8ee0fe114fb1",
            "Name": "Ben",
            "Status": "ACTIVE",
            "HasValidationErrors": false,
            "IsDeleted": false,
            "IsArchived": false,
            "IsActive": true
        },
        {
            "TrackingOptionID": "c97aea16-cfd7-4db0-83bf-c0962fdac63c",
            "Name": "Clint",
            "Status": "ACTIVE",
            "HasValidationErrors": false,
            "IsDeleted": false,
            "IsArchived": false,
            "IsActive": true
        },
        {
            "TrackingOptionID": "e9224d99-8cbb-4cc2-b6d8-a53a0c0f8324",
            "Name": "COST",
            "Status": "ACTIVE",
            "HasValidationErrors": false,
            "IsDeleted": false,
            "IsArchived": false,
            "IsActive": true
        },
        {
            "TrackingOptionID": "1b7e4f01-9c48-4ade-aedc-bb0109c4ab21",
            "Name": "DAN",
            "Status": "ACTIVE",
            "HasValidationErrors": false,
            "IsDeleted": false,
            "IsArchived": false,
            "IsActive": true
        },
        {
            "TrackingOptionID": "cce46618-4824-4541-a916-8eae73d7aefe",
            "Name": "Joshua",
            "Status": "ACTIVE",
            "HasValidationErrors": false,
            "IsDeleted": false,
            "IsArchived": false,
            "IsActive": true
        },
        {
            "TrackingOptionID": "86e24b2a-4a66-4cf2-8de8-0d9badb99c6e",
            "Name": "Lorenz",
            "Status": "ACTIVE",
            "HasValidationErrors": false,
            "IsDeleted": false,
            "IsArchived": false,
            "IsActive": true
        },
        {
            "TrackingOptionID": "9225e466-143a-4c2f-b9e6-c959e24e3864",
            "Name": "Matthew",
            "Status": "ACTIVE",
            "HasValidationErrors": false,
            "IsDeleted": false,
            "IsArchived": false,
            "IsActive": true
        },
        {
            "TrackingOptionID": "753fbb40-7238-4ed7-a8fe-5fafe5b90b26",
            "Name": "Office",
            "Status": "ACTIVE",
            "HasValidationErrors": false,
            "IsDeleted": false,
            "IsArchived": false,
            "IsActive": true
        },
        {
            "TrackingOptionID": "59cb13d3-5d21-4e7d-b1d8-7284371a7ea9",
            "Name": "Reschedule",
            "Status": "ACTIVE",
            "HasValidationErrors": false,
            "IsDeleted": false,
            "IsArchived": false,
            "IsActive": true
        },
        {
            "TrackingOptionID": "9df251c5-4b88-4fe5-9bc4-f880ff1be66e",
            "Name": "Ryan",
            "Status": "ACTIVE",
            "HasValidationErrors": false,
            "IsDeleted": false,
            "IsArchived": false,
            "IsActive": true
        },
        {
            "TrackingOptionID": "e89a70b6-df79-4a3c-b3b4-427b1b5b865b",
            "Name": "VACANT",
            "Status": "ACTIVE",
            "HasValidationErrors": false,
            "IsDeleted": false,
            "IsArchived": false,
            "IsActive": true
        }],
    periods: [],
    accounts: [{
        "AccountID": "8febeaaf-4773-4002-955b-987d2d15965e",
        "Code": "201",
        "Name": "Sales (30%)",
        "Status": "ACTIVE",
        "Type": "REVENUE",
        "TaxType": "OUTPUT2",
        "Description": "",
        "Class": "REVENUE",
        "EnablePaymentsToAccount": false,
        "ShowInExpenseClaims": false,
        "BankAccountType": "",
        "ReportingCode": "REV",
        "ReportingCodeName": "Revenue",
        "HasAttachments": false,
        "UpdatedDateUTC": "/Date(1481812238787+0000)/",
        "AddToWatchlist": false
    },
        {
            "AccountID": "2f3b6e66-e052-4cb7-aa39-4807c1c93537",
            "Code": "202",
            "Name": "Sales (35%)",
            "Status": "ACTIVE",
            "Type": "REVENUE",
            "TaxType": "OUTPUT2",
            "Description": "",
            "Class": "REVENUE",
            "EnablePaymentsToAccount": false,
            "ShowInExpenseClaims": false,
            "BankAccountType": "",
            "ReportingCode": "REV",
            "ReportingCodeName": "Revenue",
            "HasAttachments": false,
            "UpdatedDateUTC": "/Date(1481812262337+0000)/",
            "AddToWatchlist": false
        },
        {
            "AccountID": "1522b6c1-e662-49b6-97fe-b75a303fc31a",
            "Code": "203",
            "Name": "Sales (40%)",
            "Status": "ACTIVE",
            "Type": "REVENUE",
            "TaxType": "OUTPUT2",
            "Description": "",
            "Class": "REVENUE",
            "EnablePaymentsToAccount": false,
            "ShowInExpenseClaims": false,
            "BankAccountType": "",
            "ReportingCode": "REV",
            "ReportingCodeName": "Revenue",
            "HasAttachments": false,
            "UpdatedDateUTC": "/Date(1481812271607+0000)/",
            "AddToWatchlist": false
        },
        {
            "AccountID": "042ea31d-147c-4c03-9701-23c136d2e1e2",
            "Code": "204",
            "Name": "Sales (50%)",
            "Status": "ACTIVE",
            "Type": "REVENUE",
            "TaxType": "OUTPUT2",
            "Description": "",
            "Class": "REVENUE",
            "EnablePaymentsToAccount": false,
            "ShowInExpenseClaims": false,
            "BankAccountType": "",
            "ReportingCode": "REV",
            "ReportingCodeName": "Revenue",
            "HasAttachments": false,
            "UpdatedDateUTC": "/Date(1481812286120+0000)/",
            "AddToWatchlist": false
        },
        {
            "AccountID": "47692841-9a38-4188-8dd1-4e607f227839",
            "Code": "205",
            "Name": "Sales (60%)",
            "Status": "ACTIVE",
            "Type": "REVENUE",
            "TaxType": "OUTPUT2",
            "Description": "",
            "Class": "REVENUE",
            "EnablePaymentsToAccount": false,
            "ShowInExpenseClaims": false,
            "BankAccountType": "",
            "ReportingCode": "REV",
            "ReportingCodeName": "Revenue",
            "HasAttachments": false,
            "UpdatedDateUTC": "/Date(1481812295703+0000)/",
            "AddToWatchlist": false
        },
        {
            "AccountID": "a9b61c97-90ee-4e89-940f-5cf1862e5336",
            "Code": "206",
            "Name": "Sales (100%)",
            "Status": "ACTIVE",
            "Type": "REVENUE",
            "TaxType": "OUTPUT2",
            "Description": "",
            "Class": "REVENUE",
            "EnablePaymentsToAccount": false,
            "ShowInExpenseClaims": false,
            "BankAccountType": "",
            "ReportingCode": "REV",
            "ReportingCodeName": "Revenue",
            "HasAttachments": false,
            "UpdatedDateUTC": "/Date(1556109953587+0000)/",
            "AddToWatchlist": false
        }]
}
